export const PLAYER_PAGE_TAB_SLUGS = [
  "overview",
  "matches",
  "stats",
  "events",
  "shots",
  "crosses",
];

export const DEFAULT_PLAYER_PAGE_TAB_INDEX = 0;

const normalizeHashValue = (hash = "") => {
  if (typeof hash !== "string") {
    return "";
  }

  return hash.replace(/^#/, "").trim().toLowerCase();
};

export const getPlayerPageTabIndexFromHash = (hash = "") => {
  const normalizedHash = normalizeHashValue(hash);
  const matchedIndex = PLAYER_PAGE_TAB_SLUGS.indexOf(normalizedHash);

  return matchedIndex === -1
    ? DEFAULT_PLAYER_PAGE_TAB_INDEX
    : matchedIndex;
};

export const getPlayerPageTabHashByIndex = (index) => {
  const tabSlug =
    PLAYER_PAGE_TAB_SLUGS[index] ??
    PLAYER_PAGE_TAB_SLUGS[DEFAULT_PLAYER_PAGE_TAB_INDEX];

  return `#${tabSlug}`;
};
